import type { TransformerExtended } from "@/Common/Models/Domain/Transformer";

import type { PatientInfoApi } from "@/Modules/Models/Api/ClinicalHistory";
import type { PatientInfo } from "@/Modules/Models/Domain/ClinicalHistory";

import camel from "@/Utils/Camelize";
import DefaultTransformerGenerator from "@/Common/Transformers/FunctionalBase";

const PatientInfoTransformer: TransformerExtended<PatientInfo, PatientInfoApi> = {
  ...DefaultTransformerGenerator<PatientInfo, PatientInfoApi>(),

  toDomain(input: PatientInfoApi) {
    return camel<PatientInfoApi>(input) as PatientInfo;
  },
};

export type PatientInfoTransformerType = TransformerExtended<PatientInfo, PatientInfoApi>;

export default PatientInfoTransformer;
